<template lang="pug">
.searchPanel
  .simpleSearch(v-if="filtro.simples", key="simpleSearch")
    form(@submit.prevent="$emit('pesquisar', filtro)")
      el-input.input(
        :placeholder="placeholder",
        v-model="filtro.campoSimples",
        class="input-with-select"
      )
        el-button.color-default(
          slot="append",
          icon="el-icon-search",
          id='botao-filtro-simplificado'
          @click="pesquisar"
        )
  .loteSearch(v-if="filtro.lote", key="loteSearch")
    el-card.card-container
      el-row(:gutter="10")
        div.row
          span
            p.busca Pesquisa por lote
          el-tooltip(
            effect='dark',
            placement="top-end"
          )
            i.el-icon-info.icon-info
            template(slot="content") Para realizar a pesquisa de mais de um processo, insira a planilha contendo os números dos processos a serem pesquisados de acordo com o modelo a seguir.&nbsp
              a.btn-download(@click="baixarModelo") (Baixar modelo)
        div
          app-upload-area(
            id="lote",
            :target="'publico/upload'"
            :fileType="validExtensions"
            :onSuccess="onSuccess"
            :documento="file"
            :hasDownloadButton="false",
            v-model="file"
            @removerDocumento="removerDocumento"
          )
  .advancedSearch(v-if="filtro.avancada")
    form(@submit.prevent="$emit('pesquisar', filtro)")
      .panel
        el-row(:gutter="10")
          el-col(:lg="6", :md="12", :sm="24")
            p.titulo Processo:
            el-input(
              v-model="filtro.numeroProcesso",
              v-mask="['#########/####']"
            )
          el-col(:lg="6", :md="12", :sm="24", v-if="showfiltrosInformacoes")
            p.titulo Período de Solicitação:
            el-date-picker.full-width.input.date(
              v-bind="$attrs",
              type="daterange",
              start-placeholder="Período inicial",
              end-placeholder="Período Final",
              format="dd/MM/yyyy",
              v-model="filtro.periodoSolicitacao"
              name='data',
            )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroDataChegada")
            p.titulo Período de Chegada:
            el-date-picker.full-width.input.date(
              type="daterange",
              start-placeholder="Período Inicial",
              end-placeholder="Período Final",
              format="dd/MM/yyyy",
              v-model="filtro.dataChegadaSetor",
              @change="formatarDatas"
            )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroResponsavel')")
            p.titulo Responsável:
            el-select.full-width(
              v-model='filtro.responsavel',
              placeholder='Selecione',
              clearable,
              filterable,
              no-match-text="Responsável não encontrado",
              @clear="filtro.responsavel = null"
            )
              el-option(
                v-for='responsavel in responsaveis',
                :key='responsavel.id',
                :label='responsavel.nomeCargo',
                :value='responsavel.id'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroCredenciado')")
            p.titulo Credenciado:
            el-select.full-width(
              v-model='filtro.credenciado',
              placeholder='Selecione',
              clearable,
              filterable,
              no-match-text="Credenciado não encontrado",
              @clear="filtro.credenciado = null"
            )
              el-option(
                v-for='credenciado in credenciados',
                :key='credenciado',
                :label='credenciado',
                :value='credenciado'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroCredenciadoGeo')")
            p.titulo Credenciado:
            el-select.full-width(
              v-model='filtro.credenciado',
              placeholder='Selecione',
              clearable,
              filterable,
              no-match-text="Credenciado não encontrado",
              @clear="filtro.credenciado = null"
            )
              el-option(
                v-for='credenciado in credenciados',
                :key='credenciado.codigo',
                :label='credenciado.nome',
                :value='credenciado.codigo'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroVistoriador')")
            p.titulo Credenciado:
            el-select.full-width(
              v-model='filtro.tipoCredenciado',
              placeholder='Selecione',
              clearable,
              @clear="filtro.tipoCredenciado = null"
            )
              el-option(
                v-for='tipo in tipoCredenciado',
                :key='tipo.codigo',
                :label='tipo.name',
                :value='tipo.codigo'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroSituacaoTituloCertidao')")
            p.titulo Situação:
            el-select.full-width(
              v-model='filtro.status',
              placeholder='Selecione',
              clearable
            )
              el-option(
                v-for='situacao in situacaoTituloCertidao',
                :key='situacao.codigo',
                :label='situacao.nome',
                :value='situacao.codigo'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroBairro') && !isMa")
            p.titulo Bairro:
            el-input(
              v-model="filtro.bairro"
            )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroOS')")
            p.titulo Ordem de Serviço:
            el-select.full-width(
              v-model='filtro.numeroOs',
              placeholder='Selecione',
              clearable,
              filterable
            )
              el-option(
                v-for='ordemServico in ordemServicoList',
                :key='ordemServico.id',
                :label='ordemServico.label',
                :value='ordemServico.label'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroOrdemServico')")
            p.titulo Ordem de Serviço:
            el-input(
              v-model="filtro.numeroOs"
            )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroFuncao')")
            p.titulo Função:
            el-select.full-width(
              v-model='filtro.funcao',
              placeholder='Selecione',
              clearable
            )
              el-option(
                v-for='funcao in funcoes',
                :key='funcao.codigo',
                :label='funcao.nome',
                :value='funcao.codigo'
              )
          div
            el-col(:lg="6", :md="12", :sm="24", v-if="(!showfiltrosInformacoes && !showFiltroPublicacaoPortaria && !showFiltroPublicacao) && !(isBa && caixa === 'ASSINATURAS')")
              p.titulo CPF/CNPJ do Interessado:
              el-input.input(
                v-model="filtro.cpfCnpjInteressado",
                class="input-with-select",
                v-mask="['###.###.###-##', '##.###.###/####-##']"
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showfiltrosInformacoes")
              p.titulo Setor de Origem:
              el-select.full-width(
                v-model='filtro.setorOrigem',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='setor in setores'
                  :key='setor.id'
                  :label='setor.nome',
                  :value='setor.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroSetor")
              p.titulo Setor:
              el-select.full-width(
                v-model='filtro.setor',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='setor in setores'
                  :key='setor.id'
                  :label='setor.nome',
                  :value='setor.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroSetoresTituloCertidao")
              p.titulo Setor:
              el-select.full-width(
                v-model='filtro.setorProcesso',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='(codigo, setor) in setoresTituloCertidao'
                  :key='setor'
                  :label='codigo'
                  :value='setor'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="!showfiltrosInformacoes")
              p.titulo Nome/Razão Social do Interessado:
              el-input(
                v-model="filtro.nomeInteressado"
              )
            el-col(:lg="6", :md="12", :sm="24" v-if="showFiltro('filtroClausulaResolutiva')")
              p.titulo Situação cláusula resolutiva:
              el-select.full-width(
                v-model='filtro.situacaoClausulaResolutiva',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='tipo in situacaoClausulaResolutiva',
                  :key='tipo.codigo',
                  :label='tipo.nome',
                  :value='tipo.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacaoPortaria")
                p.titulo Número portaria:
                el-input(
                  v-model="filtro.numeroPortaria"
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacaoPortaria")
              p.titulo Número publicação de portaria:
              el-input(
                v-model="filtro.numeroPublicacaoPortaria",
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacao")
              p.titulo Número publicação:
              el-input(
                v-model="filtro.numeroPublicacaoPortaria",
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacaoPortaria || showFiltroPublicacao")
              p.titulo Denominação do imóvel:
              el-input(
                v-model="filtro.denominacao",
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacaoPortaria || showFiltroPublicacao")
              p.titulo Período de publicação:
              el-date-picker.full-width.input.date(
                v-bind="$attrs",
                type="daterange",
                start-placeholder="Período inicial",
                end-placeholder="Período Final",
                format="dd/MM/yyyy",
                v-model="filtro.periodoPublicacao"
                name='data',
              )
            el-col(:lg="6", :md="12", :sm="24")
              p.titulo Tipo de processo:
              div(v-if="showFiltroTipoMultiplo")
                el-select.full-width(
                  v-model='filtro.tipos',
                  placeholder='Selecione',
                  multiple,
                  clearable
                )
                  el-option(
                    v-for='tipo in tiposCadastroSelect',
                    :key='tipo.codigo',
                    :label='tipo.nome',
                    :value='tipo.codigo'
                  )
              div(v-else)
                el-select.full-width(
                  v-model='filtro.tipo',
                  placeholder='Selecione',
                  clearable
                )
                  el-option(
                    v-for='tipo in tiposCadastroSelect',
                    :key='tipo.codigo',
                    :label='tipo.nome',
                    :value='tipo.codigo'
                  )
            el-col(:lg="12", :md="12", v-if="showFiltro('filtroSituacaoBoleto') || isCof")
              p.titulo Situação:
              el-select.full-width(
                v-model='filtro.situacao',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacaoBoleto',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroTipoPagamento') || showFiltroTipoPagamentoCOF")
              p.titulo Tipo de Pagamento:
              el-select.full-width(
                v-model='filtro.tipoPagamentoVtn',
                placeholder='Selecione',
                clearable
              )
                el-option(key='A_VISTA', label='À vista', value='A_VISTA')
                el-option(key='PARCELADO', label='À prazo', value='PARCELADO')
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroSituacao') && !showFiltro('isCPAV')")
              p.titulo Situação:
              el-select.full-width(
                v-model='filtro.status',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacoes',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24" v-if="!(isBa && caixa === 'ASSINATURAS')")
              p.titulo Município:
              el-select.full-width(
                multiple
                v-model='filtro.municipio',
                placeholder='Selecione',
                clearable,
                filterable,
                no-match-text="Município não encontrado",
                @clear="filtro.municipio = null"
              )
                el-option(
                  v-for='m in municipios',
                  :key='m.id',
                  :label='m.nome',
                  :value='m.id'
                )
            el-col(:lg="6", :md="12", :sm="24" v-if="showFiltro('filtroBairro') && isMa")
              p.titulo Bairro:
              el-select.full-width(
                v-model='filtro.bairros',
                placeholder='Selecione',
                clearable,
                filterable,
                multiple,
                no-match-text="Bairro não encontrado",
                @clear="filtro.bairro = null"
                :disabled="bairrosMunicipioSelecionado.length === 0"
              )
                el-option(
                  v-for='b in bairrosMunicipioSelecionado',
                  :key='b.nome',
                  :label='b.nome',
                  :value='b.nome'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showfiltrosInformacoes")
              p.titulo Status:
              el-select.full-width(
                v-model='filtro.status',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='status in statusSolicitacao',
                  :key='status.codigo',
                  :label='status.nome',
                  :value='status.codigo'
                )

          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroDataEmissaoTitulo")
            p.titulo Data de emissão do título:
            el-date-picker.full-width.input.date(
              v-bind="$attrs",
              type="daterange",
              start-placeholder="Período inicial",
              end-placeholder="Período Final",
              format="dd/MM/yyyy",
              v-model="filtro.dataEmissaoTitulo"
              name='data',
            )

          el-col(:lg="6", :md="12", v-if="showFiltro('filtroSituacaoAssinatura')")
            p.titulo Situação:
            el-select.full-width(
              v-model='filtro.status',
              placeholder='Selecione',
              clearable
            )
              el-option(
                v-for='situacao in situacaoAssinaturaGabBA',
                :key='situacao.codigo',
                :label='situacao.nome',
                :value='situacao.codigo'
              )

          div(v-if="listaProcessosSelecionados")
            el-col.column-checkbox(:lg="6", :md="12", :sm="24" v-if="(!showFiltroPublicacaoPortaria && !showFiltroPublicacao)")
              el-checkbox(
                v-model="exibirProcessosSelecionados"
                @change="setCheckboxProcessosSelecionados()"
              )
                label.titulo Exibir apenas selecionados
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroStatusOrdemServico')")
              p.titulo Status da Ordem de Serviço:
              el-select.full-width(
                v-model='filtro.status',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='status in statusOs',
                  :key='status.codigo',
                  :label='status.nome',
                  :value='status.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroTitulo')")
              p.titulo Título/Certidão:
              el-input(
                v-model="filtro.numeroTitulo"
              )
            el-col(:lg="6", :md="12", v-if="showFiltro('filtroMunicipio')")
              p.titulo Município:
              el-select.full-width(
                multiple
                v-model='filtro.municipio',
                placeholder='Selecione',
                clearable,
                filterable,
                no-match-text="Município não encontrado",
                @clear="filtro.municipio = null"
              )
                el-option(
                  v-for='m in municipios',
                  :key='m.id',
                  :label='m.nome',
                  :value='m.id'
                )
            el-col(:lg="6", :md="12", v-if="showFiltro('filtroReceita')")
              p.titulo Receita:
              el-select.full-width(
                v-model='filtro.receita',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='receita in receitas',
                  :key='receita.codigo',
                  :label='receita.descricao',
                  :value='receita.id'
                )
            el-col(:lg="12", :md="12", v-if="showFiltro('filtroSituacao') && showFiltro('isCPAV')")
              p.titulo Situação:
              el-select.full-width(
                v-model='filtro.status',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacoesCPAV',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )

            el-col(:lg="6", :md="12", v-if="showFiltro('filtroSituacaoCertidao')")
              p.titulo Situação Certidão:
              el-select.full-width(
                v-model='filtro.situacaoCertidao',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacoesCertidao',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )
            el-col(:lg="6", :md="12", v-if="showFiltro('filtroDataVencimento')")
              p.titulo Data de Vencimento:
              el-date-picker.full-width.input.date(
                v-bind="$attrs",
                type="daterange",
                start-placeholder="Data inicial",
                end-placeholder="Data Final",
                format="dd/MM/yyyy",
                v-model="filtro.dataVencimento"
                name='data',
              )
            el-col(:lg="6", :md="12", v-if="showFiltro('filtroArquivadosGac')")
              p.titulo Data de Arquivamento:
              el-date-picker.full-width.input.date(
                v-bind="$attrs",
                type="daterange",
                start-placeholder="Data inicial",
                end-placeholder="Data Final",
                format="dd/MM/yyyy",
                v-model="filtro.dataArquivamento"
                name='data',
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroSituacaoBoleto')")
              p.titulo Situação:
              el-select.full-width(
                v-model='filtro.situacao',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacaoBoleto',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroRua')")
              p.titulo Rua:
              el-input(
                v-model="filtro.rua"
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroBairro')")
              p.titulo Bairro:
              el-input(
                v-model="filtro.bairro"
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroRemessa')")
              p.titulo Remessa:
              el-input(
                v-model="filtro.remessa"
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroQuadra')")
              p.titulo Quadra:
              el-input(
                v-model="filtro.quadra"
              )
  .button-group
    .left-buttons
      el-button.no-padding(
        v-if="showButtonSearch === 'AVANÇADA' || showButtonSearch === 'LOTE'"
        type="text",
        @click="changePesquisa('SIMPLES')"
      ) Pesquisa simples
      el-button.no-padding(
        v-if="showButtonSearch === 'SIMPLES' || showButtonSearch === 'LOTE'"
        type="text",
        @click="changePesquisa('AVANÇADA')"
      ) Pesquisa avançada
      el-button.no-padding(
        v-if="showButtonSearch === 'SIMPLES' || showButtonSearch === 'AVANÇADA'"
        type="text",
        @click="changePesquisa('LOTE')"
      ) Pesquisa por lote
      el-button.no-padding(
        type="text",
        @click="limpar"
      ) Limpar
    .right-buttons
      el-button.btn(
        v-if="!filtro.simples",
        type="primary",
        id='botao-filtro-avancado'
        @click="pesquisar"
      )
        i.el-icon-search
        | &nbsp Pesquisar
</template>

<script>
import axios from '@/utils/api'
import FILTRO_EMPTY from '@/models/filtro'
import { mapActions, mapGetters } from 'vuex'
import AppUploadArea from '@/components/AppUploadArea'
import { funcoes, tiposNaoOnerosoGroup, tiposPeasGroup, statusOs, situacaoBoleto, situacoesCertidao, statusSolicitacao, situacaoTituloCertidao, situacoesArquivados, situacaoClausulaResolutiva, situacoesCPAV, situacaoTituloCertidaoMa, situacaoTituloCertidaoBa, situacaoBA, situacaoAssinaturaGabBA, situacaoTituloCertidaoAp } from '@/constants/selects'
import PermissaoHelper from '@/screens/analise/PermissaoHelper'
const { filtro, getOpcoesCredenciadoByPerfil } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const { tiposProcessos } = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default
const { setoresTituloCertidao, setoresFormatado } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {
  components: {
    AppUploadArea
  },

  mixins: [
    PermissaoHelper
  ],

  props: {
    showPesquisaAvancada: {
      type: Boolean,
      default: true
    },
    showFiltroDataEmissaoTitulo: {
      type: Boolean,
      default: false
    },
    configuracaoFiltro: {
      type: Object,
      required: true
    },
    showFiltroTipoPagamentoCOF: {
      type: Boolean,
      default: false
    },
    isCof: {
      type: Boolean,
      default: false
    },
    showfiltrosInformacoes: {
      type: Boolean,
      default: false
    },
    showFiltroSetor: {
      type: Boolean,
      default: false
    },
    showFiltroDataChegada: {
      type: Boolean,
      default: false
    },
    showFiltroSetoresTituloCertidao: {
      type: Boolean,
      default: false
    },
    listaProcessosSelecionados: {
      default: false
    },
    placeholder: {
      type: String,
      default: filtro.placeholder
    },
    filtroRapido: {
      type: Object,
      required: false
    },
    showFiltroPublicacaoPortaria: {
      type: Boolean,
      default: false
    },
    showFiltroPublicacao: {
      type: Boolean,
      default: false
    },
    showFiltroTipoMultiplo: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      funcoes,
      caixa: '',
      tiposNaoOnerosoGroup,
      tiposPeasGroup,
      statusSolicitacao,
      statusOs,
      situacoesCPAV,
      situacaoAssinaturaGabBA,
      situacaoBoleto,
      situacoesCertidao,
      situacaoClausulaResolutiva,
      situacaoTituloCertidao: process.env.ESTADO === 'ma' ? situacaoTituloCertidaoMa : process.env.ESTADO === 'ba' ? situacaoTituloCertidaoBa : process.env.ESTADO === 'ap' ? situacaoTituloCertidaoAp : situacaoTituloCertidao,
      situacoes: [],
      setores: [],
      exibirProcessosSelecionados: false,
      municipios: [],
      situacoesArquivados,
      filtro: FILTRO_EMPTY(),
      setoresTituloCertidao: setoresTituloCertidao,
      credenciados: null,
      tipoCredenciado: [],
      isBa: process.env.ESTADO === 'ba',
      isMa: process.env.ESTADO === 'ma',
      isPa: process.env.ESTADO === 'pa',
      ordemServicoList: [],
      validExtensions: process.env.ESTADO === 'ma' ? ['xlsx'] : ['xlsx', 'xls', 'csv'],
      file: null,
      showButtonSearch: 'SIMPLES',
      bairrosMunicipioSelecionado: [],
      mapListMunicipiosBairros: []
    }
  },

  async mounted () {
    this.municipios = await this.findMunicipiosByEstadoAtual()
    this.caixa = this.$route.name
    if (this.configuracaoFiltro?.filtroCredenciado &&
      this.configuracaoFiltro?.filtroCredenciado.some(e => e === this.usuario.perfilSelecionado.codigo)
    ) {
      this.credenciados = await this.findAllCredenciadoVistoria()
    }
    if (this.configuracaoFiltro?.filtroCredenciadoGeo &&
      this.configuracaoFiltro?.filtroCredenciadoGeo.some(e => e === this.usuario.perfilSelecionado.codigo)
    ) {
      this.credenciados = await this.findAllCredenciadoGeo()
    }
    if (this.caixa && (this.caixa !== 'portariaHomologacao' && this.caixa !== 'publicacao')) {
      this.responsaveis = await this.getUsuariosPorSetor(this.caixa)
      if (this.showfiltrosInformacoes || this.showFiltroSetor) {
        this.setores = await axios({
          method: 'GET',
          url: `solicitarInformacao/setores`,
          error: true
        })
        this.setores = this.setores.map(s => ({ ...s, nome: setoresFormatado[s.codigo] }))
      }
      const caixa = this.caixa === 'cof/gestaoVtn' ? 'GESTAO_VTN' : (this.caixa === 'gat/informacoesSolicitadas' || this.caixa === 'cof/informacoesSolicitadas' ? 'INFORMACAO_SOLICITADA' : this.caixa)
      if (this.isBa) {
        this.situacoes = situacaoBA
      } else {
        this.situacoes = await axios({
          method: 'GET',
          url: `processo/getSituacoesBycaixa/${caixa}`,
          loader: false
        })
      }
    }
    if (this.configuracaoFiltro?.filtroVistoriador) {
      this.tipoCredenciado = getOpcoesCredenciadoByPerfil(this.usuario.perfilSelecionado.codigo)
    }
    if (this.isBa) {
      this.funcoes = this.funcoes.filter(f => ['GEOMENSOR', 'VISTORIADOR'].includes(f.codigo))
    }
    if (this.showFiltro('filtroOS')) {
      this.ordemServicoList = await axios({
        method: 'GET',
        url: 'ordemServico/select/getAll'
      })
    }
    if (this.isMa) {
      this.buscarMunicipiosBairros()
    }
  },

  computed: {

    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),

    tituloPesquisa () {
      return this.filtro.simples && this.filtro.lote ? 'Pesquisa avançada' : 'Pesquisa simplificada'
    },
    tiposCadastroSelect () {
      if (this.isMa && this.$route.name === 'PROCESSO_ARQUIVADO' && this.usuario.perfilSelecionado?.codigo.includes('COMISSAO_ILHA')) {
        return tiposProcessos.filter(tipo => tipo?.codigo === 'REURB_COLETIVO' || tipo?.codigo === 'REURB_INDIVIDUAL')
      }
      if (this.isPa && this.$route.fullPath === '/analise/RELATORIO_CREDENCIADOS') {
        return tiposProcessos.filter(tipo => tipo?.codigo === 'ONEROSO' || tipo?.codigo === 'NAO_ONEROSO' || tipo?.codigo === 'CERTIDAO_TITULO')
      }
      return tiposProcessos
    }
  },

  methods: {
    ...mapActions({
      getUsuariosPorSetor: 'dados/getUsuariosPorSetor',
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual',
      findAllCredenciadoVistoria: 'pessoa/findAllCredenciadoVistoria',
      findAllCredenciadoGeo: 'pessoa/findAllCredenciadoGeo',
      getModeloRelatorio: 'dashboardRelatorios/downloadModelo'
    }),

    baixarModelo () {
      this.getModeloRelatorio()
    },

    async buscarMunicipiosBairros () {
      if (this.mapListMunicipiosBairros.length === 0) {
        const response = await axios({
          method: 'GET',
          url: 'processo/findMunicipiosBairrosReurbIndividual',
          loader: false,
          error: false
        })
        this.mapListMunicipiosBairros = response
      }
    },

    async setarBairrosMunicipioSelecionado () {
      if (this.filtro.municipio && this.filtro.municipio.length > 0) {
        this.bairrosMunicipioSelecionado = this.mapListMunicipiosBairros
          .filter(map => this.filtro.municipio.includes(map.municipio))
          .filter(map => !this.bairrosMunicipioSelecionado.includes(map.bairro))
          .map(map => ({nome: map.bairro}))
      } else {
        this.bairrosMunicipioSelecionado = []
      }
    },

    onSuccess (id, resumableFile, fileKey) {
      this.file = {
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size
      }
      this.filtro.nomePlanilha = this.file.fileKey
    },

    removerDocumento () {
      this.file = null
      this.filtroSearch.nomePlanilha = null
    },

    showFiltro (campo) {
      if (!this.usuario) {
        return false
      }
      return this.configuracaoFiltro[campo] && this.configuracaoFiltro[campo].find((perfil) => perfil === this.usuario?.perfilSelecionado.codigo)
    },

    limpar () {
      this.filtro = { ...FILTRO_EMPTY(),
        simples: this.filtro.simples,
        avancada: this.filtro.avancada,
        lote: this.filtro.lote }
      this.exibirProcessosSelecionados = false
      this.$emit('limpar')
      if (this.filtro.lote) {
        this.removerDocumento()
      }
    },

    changePesquisa (value) {
      this.showButtonSearch = value
      this.filtro.simples = value === 'SIMPLES'
      this.filtro.avancada = value === 'AVANÇADA'
      this.filtro.lote = value === 'LOTE'
      this.filtro.campoSimples = ''
      this.filtro.cpfCnpjInteressado = ''
      this.filtro.nomeInteressado = ''
      this.filtro.numeroProcesso = ''
      this.filtro.municipio = []
      this.filtro.bairro = ''
      this.filtro.bairros = []
      this.filtro.funcao = ''
      this.filtro.setorOrigem = ''
      this.filtro.tipo = ''
      this.filtro.dataVencimento = null
      this.filtro.dataArquivamento = null
      this.filtro.situacao = ''
      this.filtro.status = ''
      this.filtro.statusSolicitacao = ''
      this.filtro.statusOs = ''
      this.filtro.situacaoCertidao = ''
      this.filtro.tipoPagamentoVtn = ''
      this.filtro.situacaoClausulaResolutiva = ''
      this.filtro.ordem = ''
      this.filtro.receita = ''
      this.filtro.responsavel = ''
      this.filtro.setorOrigem = ''
    },

    pesquisar () {
      if (this.filtroRapido) {
        this.filtro = {
          ...this.filtro,
          ...this.filtroRapido
        }
      }
      this.$emit('pesquisar', this.filtro)
    },

    formatResponsavel (responsavel) {
      if (!this.showFuncaoResponsavel) {
        return responsavel.pessoa.pessoaFisica.nome
      }

      return `${responsavel.pessoa.pessoaFisica.nome} (${responsavel.perfis ? responsavel.perfis[0].nome : ''})`
    },

    setCheckboxProcessosSelecionados () {
      if (this.exibirProcessosSelecionados) {
        this.filtro.processos = this.listaProcessosSelecionados
      } else {
        this.filtro.processos = []
      }
    },

    formatarDatas () {
      if (this.filtro.dataChegadaSetor) {
        const inicio = new Date(this.filtro.dataChegadaSetor[0])
        const fim = new Date(this.filtro.dataChegadaSetor[1])

        inicio.setHours(0, 0, 0, 0)
        fim.setHours(23, 59, 59, 999)

        this.filtro.dataChegadaSetor = [inicio, fim]
      }
    }
  },

  watch: {
    'filtro.municipio': function (novoValor) {
      if (novoValor && novoValor.length > 0) {
        this.setarBairrosMunicipioSelecionado()
      } else {
        this.bairrosMunicipioSelecionado = []
        this.filtro.bairros = []
      }
    },
    bairrosMunicipioSelecionado: function (bairros) {
      if (!bairros || bairros.length === 0) {
        this.filtro.bairros = []
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/styles/element-variables.scss';
@import '@/assets/styles/element-variables.scss';

.color-default {
  color: #009d64 !important;
  font-size: 16px;
}

.searchPanel {
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  .button-group {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 15px;
  }

  .no-padding {
    padding: 0;
  }

  .panel {
    .margin-top {
      margin-top: 10px;
    }

    .titulo {
      font-size: 14px;
    }
  }

  .btn {
    padding: 8px;
  }
}

.column-checkbox {
  padding-top: 20px;
  padding-bottom: 20px;
}

.full-width {
  width: 100%;
}

.titulo {
  margin: 0;
  padding: 12px 0 8px 0px;
}

.btn-download {
  text-decoration: underline;
  cursor: pointer;
  color: #f1f1f1;
}

.busca {
  padding: 12px 0 8px 0px;
  text-align: left;
  color: $--color-primary !important;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.icon-info {
  font-size: 25;
  margin: 0 0 10px 5px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/FiltroWithLote.vue